import React, { useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../core/redux/action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft,ChevronDown,ChevronUp,Info,LifeBuoy} from "feather-icons-react/build/IconComponents";
import { all_routes } from "../../Router/all_routes";
import { renderRequired, renderOptional } from '../../feature-module/common/common.js';


const ManageEmployees = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    dob: "",
    gender: "",
    joiningDate: "",
    designation: null,
    department: null,
    emergencyNumber: "",
    country: null,
    state: null,
    city: null,
    zipCode: "",
    address: "",
  });

  const [errors, setErrors] = useState({});

  const designationOptions = [
    { value: "manager", label: "Manager" },
    { value: "developer", label: "Developer" },
    { value: "designer", label: "Designer" },
  ];

  const departmentOptions = [
    { value: "hr", label: "HR" },
    { value: "engineering", label: "Engineering" },
    { value: "marketing", label: "Marketing" },
  ];

 

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName) newErrors.firstName = "First Name is required";
    if (!formData.lastName) newErrors.lastName = "Last Name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.contactNumber) newErrors.contactNumber = "Contact Number is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.joiningDate) newErrors.joiningDate = "Joining Date is required";
    if (!formData.designation) newErrors.designation = "Designation is required";
    if (!formData.department) newErrors.department = "Department is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSelectChange = (name) => (selectedOption) => {
    setFormData({ ...formData, [name]: selectedOption });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    console.log("Form Data:", formData);

  };

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>New Employee</h4>
              <h6>Create new employee</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <div className="page-btn">
                <Link to={route.employees} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  Back to Employee List
                </Link>
              </div>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Collapse"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp className="feather-chevron-up" />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>
    
        <form onSubmit={handleSubmit}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div className="accordion-card-one accordion" id="accordionExample">
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <div className="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-controls="collapseOne">
                      <div className="addproduct-icon">
                        <h5>
                          <Info className="add-info" />
                          <span>General Information</span>
                        </h5>
                        <Link to="#">
                          <ChevronDown className="chevron-down-add" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">First Name {renderRequired()}</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter First Name"
                              name="firstName"
                              value={formData.firstName}
                              onChange={handleChange}
                            />
                            {errors.firstName && <div className="text-danger">{errors.firstName}</div>}
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Last Name {renderRequired()}</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Last Name"
                              name="lastName"
                              value={formData.lastName}
                              onChange={handleChange}
                            />
                            {errors.lastName && <div className="text-danger">{errors.lastName}</div>}
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Email {renderRequired()}</label>
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Enter Email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                            />
                            {errors.email && <div className="text-danger">{errors.email}</div>}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Contact Number {renderRequired()}</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Contact Number"
                              name="contactNumber"
                              value={formData.contactNumber}
                              onChange={handleChange}
                            />
                            {errors.contactNumber && <div className="text-danger">{errors.contactNumber}</div>}
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Date of Birth</label>
                            <input
                              type="date"
                              className="form-control"
                              name="dob"
                              value={formData.dob}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Gender {renderRequired()}</label>
                            <div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="gender"
                                  id="genderMale"
                                  value="male"
                                  checked={formData.gender === "male"}
                                  onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor="genderMale">Male</label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="gender"
                                  id="genderFemale"
                                  value="female"
                                  checked={formData.gender === "female"}
                                  onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor="genderFemale">Female</label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="gender"
                                  id="genderOther"
                                  value="other"
                                  checked={formData.gender === "other"}
                                  onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor="genderOther">Other</label>
                              </div>
                            </div>
                            {errors.gender && <div className="text-danger">{errors.gender}</div>}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Joining Date {renderRequired()}</label>
                            <input
                              type="date"
                              className="form-control"
                              name="joiningDate"
                              value={formData.joiningDate}
                              onChange={handleChange}
                            />
                            {errors.joiningDate && <div className="text-danger">{errors.joiningDate}</div>}
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Designation {renderRequired()}</label>
                            <Select
                              classNamePrefix="react-select"
                              options={designationOptions}
                              placeholder="Choose"
                              value={formData.designation}
                              onChange={handleSelectChange("designation")}
                            />
                            {errors.designation && <div className="text-danger">{errors.designation}</div>}
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">Department {renderRequired()}</label>
                            <Select
                              classNamePrefix="react-select"
                              options={departmentOptions}
                              placeholder="Choose"
                              value={formData.department}
                              onChange={handleSelectChange("department")}
                            />
                            {errors.department && <div className="text-danger">{errors.department}</div>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-card-one accordion" id="accordionExample2">
                <div className="accordion-item">
                  <div className="accordion-header" id="headingTwo">
                    <div className="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-controls="collapseTwo">
                      <div className="text-editor add-list">
                        <div className="addproduct-icon list icon">
                          <h5>
                            <LifeBuoy className="add-info" />
                            <span>Additional Information</span>
                            <span style={{fontWeight:'400'}}>{renderOptional()}</span>
                          </h5>
                          <Link to="#">
                            <ChevronDown className="chevron-down-add" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="collapseTwo" className="accordion-collapse collapse show" aria-labelledby="headingTwo" data-bs-parent="#accordionExample2">
                    <div className="accordion-body">
                      <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks add-product">
                            <label>Emergency Number {renderOptional()}</label>
                            <input
                              type="text"
                              className="form-control"
                              name="emergencyNumber"
                              value={formData.emergencyNumber}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                          <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                          <label className="form-label">Country {renderOptional()}</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Country"
                            name="country"
                            value={formData.country}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-sm-6 col-12">
                        <div className="mb-3 add-product">
                          <label className="form-label">State {renderOptional()}</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter State"
                            name="state"
                            value={formData.state}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                     </div>
                     <div className="row">
                           <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                          <label className="form-label">City {renderOptional()}</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter City"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                         <div className="col-lg-4 col-sm-6 col-12">
                           <div className="input-blocks add-product">
                             <label>Postcode {renderOptional()}</label>
                             <input
                               type="text"
                              className="form-control"
                              name="zipCode"
                              value={formData.zipCode}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="input-blocks add-product">
                            <label>Address {renderOptional()}</label>
                            <textarea
                              className="form-control"
                              rows="2"
                              name="address"
                              value={formData.address}
                              onChange={handleChange}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-end mb-3">
            <Link to={route.employees} type="button" className="btn btn-cancel me-2">
              Cancel
            </Link>
            <button type="submit" className="btn btn-submit">
              Save Employees
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ManageEmployees;

